import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { X, Check } from 'lucide-react';
export function ComparisonTable() {
  const rows = [{
    sit: 'Berrinches intensos',
    sin: 'Reaccionás en piloto automático',
    con: 'Protocolo de 3 pasos para responder con calma'
  }, {
    sit: 'Comunicación rota',
    sin: 'No sabés cómo iniciar la conversación',
    con: 'Frases exactas para reconectar en 5 minutos'
  }, {
    sit: 'Crisis de límites',
    sin: 'Cedés o explotás sin término medio',
    con: 'Sistema de límites firmes sin culpa ni gritos'
  }, {
    sit: 'Vínculo a largo plazo',
    sin: 'Vas apagando incendios sin plan',
    con: 'Plan anual de conexión mes a mes'
  }, {
    sit: 'Tu regulación emocional',
    sin: 'Dependés de tu estado de ánimo',
    con: 'Técnicas de autorregulación antes de responder'
  }];
  return <SectionWrapper data-id="element-16">
      <h2 className="text-2xl md:text-4xl font-serif font-bold text-center text-burgundy mb-6" data-id="element-17">
        🌟 ¿Qué agrega el Módulo Crianza Pro?
      </h2>

      <div className="max-w-5xl mx-auto overflow-x-auto" data-id="element-18">
        <div className="min-w-[500px] bg-white rounded-xl shadow-sm border border-dusty-rose/20 overflow-hidden" data-id="element-19">
          {/* Header */}
          <div className="grid grid-cols-3 bg-card-bg border-b border-dusty-rose/20" data-id="element-20">
            <div className="p-2 md:p-3 font-bold text-text-main text-xs md:text-sm flex items-center" data-id="element-21">
              Situación
            </div>
            <div className="p-2 md:p-3 font-bold text-text-main/60 text-center border-l border-dusty-rose/10 flex flex-col items-center justify-center text-xs md:text-sm" data-id="element-22">
              <span data-id="element-23">Sin Crianza Pro</span>
              <X className="text-red-400 mt-0.5" size={14} data-id="element-24" />
            </div>
            <div className="p-2 md:p-3 font-black text-burgundy text-center border-l border-dusty-rose/10 bg-gold/5 flex flex-col items-center justify-center text-xs md:text-sm" data-id="element-25">
              <span data-id="element-26">Con Crianza Pro</span>
              <Check className="text-green-600 mt-0.5" size={16} data-id="element-27" />
            </div>
          </div>

          {/* Rows */}
          {rows.map((row, i) => <div key={i} className={`grid grid-cols-3 border-b border-dusty-rose/10 last:border-0 ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'}`} data-id="element-28">
              <div className="p-2 md:p-3 font-medium text-text-main flex items-center text-xs md:text-sm" data-id="element-29">
                {row.sit}
              </div>
              <div className="p-2 md:p-3 text-text-main/60 text-center border-l border-dusty-rose/10 flex items-center justify-center text-xs md:text-sm" data-id="element-30">
                {row.sin}
              </div>
              <div className="p-2 md:p-3 font-bold text-burgundy text-center border-l border-dusty-rose/10 bg-gold/5 flex items-center justify-center text-xs md:text-sm" data-id="element-31">
                {row.con}
              </div>
            </div>)}
        </div>
      </div>
    </SectionWrapper>;
}